import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59da64ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = {
  class: "table",
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("td", null, "物料名称"),
  /*#__PURE__*/_createElementVNode("td", null, "物料归属")
], -1))

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { getMaterialconfig } from './material-config'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'check-material',
  setup(__props) {

const $route = useRoute()
const type = $route.query.type as string
const uav = $route.query.uav as string
const pageTitle = ref('电子件')

const tableList = getMaterialconfig(type, uav)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: pageTitle.value }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableList), (item, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(item[0]), 1),
            _createElementVNode("td", null, _toDisplayString(item[1]), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})